import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);

const KEY = "fx_cart_v1";

function load() {
    try {
        return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
        return [];
    }
}

function save(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
}

export function CartProvider({ children }) {
    const [items, setItems] = useState(load());

    useEffect(() => save(items), [items]);

    const addItem = (reward, denomination, qty = 1, points_to_use = 0) => {
        setItems((cur) => {
            const idx = cur.findIndex((i) => i.reward_id === reward.id && i.denomination === denomination);
            if (idx >= 0) {
                const copy = [...cur];
                copy[idx] = { ...copy[idx], qty: copy[idx].qty + qty };
                return copy;
            }
            return [
                ...cur,
                {
                    reward_id: reward.id,
                    brand_name: reward.brand_name,
                    brand_logo_url: reward.brand_logo_url,
                    reward_name: reward.name,
                    category: reward.category,
                    denomination,
                    qty,
                    points_to_use,
                    points_per_inr: reward.points_per_inr || 4,
                    discount_percent: reward.discount_percent || 0,
                },
            ];
        });
    };

    const updateQty = (idx, qty) => {
        setItems((cur) => {
            const c = [...cur];
            if (qty <= 0) c.splice(idx, 1);
            else c[idx] = { ...c[idx], qty };
            return c;
        });
    };

    const setPoints = (idx, pts) => {
        setItems((cur) => {
            const c = [...cur];
            c[idx] = { ...c[idx], points_to_use: Math.max(0, parseInt(pts) || 0) };
            return c;
        });
    };

    const removeItem = (idx) => setItems((cur) => cur.filter((_, i) => i !== idx));
    const clear = () => setItems([]);
    const count = items.reduce((s, i) => s + i.qty, 0);

    return (
        <CartCtx.Provider value={{ items, addItem, updateQty, setPoints, removeItem, clear, count }}>
            {children}
        </CartCtx.Provider>
    );
}

export const useCart = () => useContext(CartCtx);
